export const production = process.env.NODE_ENV === 'production';

export const serverUrl = process.env.NODE_ENV === 'development' ? 'https://dev-ibank.yelo.az' : '';

export const fileBaseURL =
  process.env.NODE_ENV === 'development' ? 'https://dev-uploader.yelo.az/api/v1' : 'https://uploader.yelo.az/api/v1';
